import { useLayoutEffect, useRef } from "react";
import { useNavigate } from "@tanstack/react-router";

/**
 * Navigates once when mounted, and again only if the target actually changes.
 *
 * TanStack ships its own <Navigate>, but it compares its props by identity and
 * React builds a new props object on every render. Components that redirect
 * typically also subscribe to the location, so each navigation re-renders them,
 * which navigates again: an unbounded loop that exhausts the heap. Comparing
 * the target by value instead gives the fire-once behaviour call sites expect.
 */
export function Navigate({ to, replace }) {
  const navigate = useNavigate();
  const navigatedTo = useRef(null);

  useLayoutEffect(() => {
    if (navigatedTo.current === to) return;
    navigatedTo.current = to;
    navigate({ to, replace });
  }, [to, replace, navigate]);

  return null;
}
